export default __webpack_public_path__ + "static/media/aws_bucket.c13efab4.svg";